// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".profile-tabs__body-name .lnr[data-v-a2110ae4]{font-size:14px}", ""]);
// Exports
module.exports = exports;
